import { useAppModal } from "@/contexts/AppModal/useAppModal";
import { DeleteRecordingModal } from "@/components/DeleteRecordingModal";
import { useDeleteRecording } from "./mutations/useDeleteRecording";
import { useCustomParams } from "@/hooks/useCustomParams";
import { useIndexDB } from "@/contexts/IndexDB/useIndexDB";
import { useRowSelection } from "@/contexts/RowSelection/useRowSelection";
import { RowSelectedType } from "@/contexts/RowSelection/RowSelectionContext";

export const useRecordingList = () => {
  const { onOpenModal, onCloseModal } = useAppModal();

  const { selecteds, resetSelection, isRowSelected, onSelect } = useRowSelection();

  const { mutate, isPending } = useDeleteRecording();

  const { deleteFromIndexDB } = useIndexDB();

  const { onChangePage } = useCustomParams();

  function handleCleanCustomSelected(selectedIds: string[]) {
    const [recordingId = ""] = selectedIds;

    if (isRowSelected(recordingId)) {
      onSelect(recordingId);
    }
  }

  async function handleOnSuccessDelete(selectedIds: string[], isDeletingIndividual: boolean) {
    if (isDeletingIndividual) {
      handleCleanCustomSelected(selectedIds);
    } else {
      resetSelection();
    }
    onCloseModal();
    onChangePage(1);

    try {
      await deleteFromIndexDB(selectedIds);
    } catch (error) {
      console.warn("Failed to remove deleted recording(s) from IndexedDB", error);
    }
  }

  function handleDeleteRow(customSelecteds?: Map<string, RowSelectedType>) {
    const isDeletingIndividual = !!customSelecteds;
    const selectedIds = customSelecteds ?? selecteds;
    const recordingIds = Array.from(selectedIds, ([key]) => key);

    mutate({ recordingIds }, { onSuccess: (_, { recordingIds }) => handleOnSuccessDelete(recordingIds, isDeletingIndividual) });
  }

  function onDeleteRow(customSelecteds?: Map<string, RowSelectedType>) {
    onOpenModal(<DeleteRecordingModal selecteds={customSelecteds ?? selecteds} onConfirm={() => handleDeleteRow(customSelecteds)} isLoading={isPending} />);
  }

  return { onDeleteRow };
};
